
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leistungen/weitere-leistungen",
      function () {
        return require("private-next-pages/leistungen/weitere-leistungen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leistungen/weitere-leistungen"])
      });
    }
  